// ==================== 响应生成器 ====================

export function generateWelcomeMessage(): string {
  return `👋 你好！我是 栩栩AI 助手，可以帮助你：

**视频分析**
- 解析抖音视频链接
- 获取视频热门评论
- 搜索特定内容的评论

**探索发现**
- 查看各品类热门视频
- 搜索相关视频
- 分析评论情感倾向

**示例指令**
- "解析 https://v.douyin.com/xxxxx"
- "获取视频 1234567890 的热门评论"
- "搜索 美妆 品类的热门视频"
- "分析一下 iPhone 的评论倾向"

有什么可以帮你的吗？`;
}

export function generateHelpMessage(): string {
  return `📖 **使用指南**

**1. 视频解析**
直接发送抖音视频链接，我会自动解析视频信息。

**2. 热门评论**
- "获取视频 1234567890 的热门评论"
- "查看 https://v.douyin.com/xxxxx 的热评"

**3. 搜索评论**
- "在视频 1234567890 中搜索 '价格' 相关评论"
- "找评论：视频ID + 关键词"

**4. 探索热门视频**
- "查看 美食 品类的热门视频"
- "搜索关于 '护肤' 的视频"

**5. 评论倾向分析**
- "分析 '火锅' 的评论倾向"
- "看看 科技 品类 iPhone 的口碑"

支持的品类：搞笑、美食、美妆、穿搭、旅行、萌宠、音乐、知识、科技、游戏、运动、汽车、家居、母婴、剧情

你可以用自然语言描述你的需求，我会尽力理解并帮助你！`;
}
